(function () {
  function initVzorkyAnnouncement() {
    document.querySelectorAll(".vzorky-announcement-wrapper").forEach(function (wrapper) {
      if (wrapper.dataset.vzorkyMoved === "true") return;
      wrapper.dataset.vzorkyMoved = "true";

      var firstHeaderSection = null;
      var main = document.getElementById("main");

      Array.from(document.body.children).forEach(function (child) {
        if (child === main) return;
        if (child.id && child.id.indexOf("shopify-section-") === 0 && !firstHeaderSection) {
          firstHeaderSection = child;
        }
      });

      if (firstHeaderSection && firstHeaderSection.parentNode) {
        firstHeaderSection.parentNode.insertBefore(wrapper, firstHeaderSection);
      }
    });
  }

  function initVzorkyStickyCta() {
    document.querySelectorAll("[data-vzorky-sticky-cta]").forEach(function (cta) {
      if (cta.dataset.vzorkyInit === "true") return;
      cta.dataset.vzorkyInit = "true";

      var heroSelector = cta.getAttribute("data-hero-selector") || ".vzorky-hero";
      var hero = document.querySelector(heroSelector);
      if (!hero) return;

      var observer = new IntersectionObserver(
        function (entries) {
          cta.classList.toggle("show", !entries[0].isIntersecting);
        },
        { rootMargin: "-40px 0px 0px 0px" }
      );

      observer.observe(hero);
    });
  }

  function initVzorkyFaq() {
    document.querySelectorAll("[data-vzorky-faq]").forEach(function (faqRoot) {
      if (faqRoot.dataset.vzorkyInit === "true") return;
      faqRoot.dataset.vzorkyInit = "true";

      faqRoot.querySelectorAll(".faq-q").forEach(function (questionButton) {
        questionButton.addEventListener("click", function () {
          var item = questionButton.parentElement;
          var answer = item.querySelector(".faq-a");
          var isOpen = item.classList.contains("open");

          faqRoot.querySelectorAll(".faq-item.open").forEach(function (openItem) {
            openItem.classList.remove("open");
            var openAnswer = openItem.querySelector(".faq-a");
            if (openAnswer) openAnswer.style.maxHeight = null;
          });

          if (!isOpen) {
            item.classList.add("open");
            if (answer) answer.style.maxHeight = answer.scrollHeight + "px";
          }
        });
      });
    });
  }

  function initVzorkyReveal() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var elements = document.querySelectorAll(".vzorky-page .reveal:not(.in)");
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function initVzorkyHeroVideo() {
    document.querySelectorAll("[data-vzorky-hero-video]").forEach(function (video) {
      if (video.dataset.vzorkyInit === "true") return;
      video.dataset.vzorkyInit = "true";

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    });
  }

  function openVzorkyCartFeedback() {
    if (document.body.classList.contains("template-cart")) return;

    if (
      window.KROWN &&
      KROWN.settings.cart_popup === "true" &&
      document.getElementById("mini-cart-popup")
    ) {
      document.getElementById("mini-cart-popup").show();
      return;
    }

    var sidebar = document.getElementById("site-cart-sidebar");
    if (
      window.KROWN &&
      KROWN.settings.cart_action === "overlay" &&
      sidebar
    ) {
      sidebar.show();
      var recommendations = document.getElementById("cart-recommendations-sidebar");
      if (recommendations && typeof recommendations.generateRecommendations === "function") {
        recommendations.generateRecommendations();
      }
    }
  }

  function initVzorkyAddToCart() {
    document.querySelectorAll("product-form.vzorky-cta-form").forEach(function (productForm) {
      if (productForm.dataset.vzorkyCartInit === "true") return;
      productForm.dataset.vzorkyCartInit = "true";

      productForm.addEventListener("add-to-cart", openVzorkyCartFeedback);
    });
  }

  function initVzorkyPopup() {
    document.querySelectorAll("[data-vzorky-popup]").forEach(function (popup) {
      if (popup.dataset.vzorkyInit === "true") return;
      popup.dataset.vzorkyInit = "true";

      var trigger = popup.getAttribute("data-trigger") || "load";
      var delay = parseInt(popup.getAttribute("data-delay"), 10) || 0;
      var once = popup.getAttribute("data-once") === "true";
      var triggerSelector = popup.getAttribute("data-trigger-selector") || "";
      var storageKey = popup.getAttribute("data-storage-key") || "vzorky-popup";
      var lastFocused = null;

      function hasBeenSeen() {
        if (!once) return false;
        try {
          return window.sessionStorage.getItem(storageKey) === "1";
        } catch (e) {
          return false;
        }
      }

      function markSeen() {
        if (!once) return;
        try {
          window.sessionStorage.setItem(storageKey, "1");
        } catch (e) {}
      }

      function open() {
        if (popup.classList.contains("is-open")) return;
        lastFocused = document.activeElement;
        popup.hidden = false;
        void popup.offsetWidth;
        popup.classList.add("is-open");
        document.body.style.overflow = "hidden";
        markSeen();
        var closeButton = popup.querySelector(".vzorky-popup__close");
        if (closeButton) closeButton.focus();
      }

      function close() {
        if (!popup.classList.contains("is-open")) return;
        popup.classList.remove("is-open");
        document.body.style.overflow = "";
        window.setTimeout(function () {
          if (!popup.classList.contains("is-open")) popup.hidden = true;
        }, 300);
        if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
      }

      popup.querySelectorAll("[data-vzorky-popup-close]").forEach(function (el) {
        el.addEventListener("click", close);
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") close();
      });

      if (triggerSelector) {
        document.addEventListener("click", function (event) {
          var match = event.target.closest(triggerSelector);
          if (!match) return;
          event.preventDefault();
          open();
        });
      }

      if (trigger === "load" && !hasBeenSeen()) {
        if (window.Shopify && window.Shopify.designMode) {
          open();
        } else {
          window.setTimeout(open, delay);
        }
      }

      popup.vzorkyOpen = open;
      popup.vzorkyClose = close;
    });
  }

  function initVzorky() {
    initVzorkyAnnouncement();
    initVzorkyStickyCta();
    initVzorkyFaq();
    initVzorkyReveal();
    initVzorkyHeroVideo();
    initVzorkyAddToCart();
    initVzorkyPopup();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initVzorky);
  } else {
    initVzorky();
  }

  document.addEventListener("shopify:section:load", initVzorky);
})();
